/* eslint-disable */
import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { configService } from "services/configService";

import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import TablePaginate from "components/TablePaginate/TablePaginate";

import Dialog from "@mui/material/Dialog";
import Edit from "@material-ui/icons/Edit";
import Search from "@material-ui/icons/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import DialogTitle from "@mui/material/DialogTitle";
import { makeStyles, Switch } from "@material-ui/core";
import DialogActions from "@mui/material/DialogActions";
import InputAdornment from "@material-ui/core/InputAdornment";

const useStyles = makeStyles({
  filter: {
    display: "flex",
    gap: "40px",
  },
});

export default function ConfigIndex() {
  const classes = useStyles();
  const [size] = React.useState(10);
  const [open, setOpen] = useState(false);
  const [page, setPage] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const [items, setItems] = React.useState([]);
  const [search, setSearch] = React.useState("");

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Key",
        accessor: "key",
      },
      {
        Header: "Value",
        accessor: "value",
      },
      {
        Header: "Unit",
        accessor: "unit",
      },
      {
        Header: "Action",
        Cell: function remove({ cell }) {
          return (
            <Action
              cell={cell}
              setItems={setItems}
              onCloseModal={handleClose}
            />
          );
        },
      },
    ],
    [handleClose, open]
  );

  async function fetchConfigData() {
    try {
      const { data } = await configService.list({
        search,
        page,
        size,
      });
      setItems(data.items);
      setCount(data.paginate.count);
      setPage(data.paginate.page);
    } catch (e) {
      console.log(e);
    }
  }

  React.useEffect(() => {
    fetchConfigData();
  }, [page, search]);

  return (
    <div>
      {confirm}
      <Link to="/admin/configs/create">
        <Button color="info">Create new config</Button>
      </Link>

      <div className={classes.filter}>
        <CustomInput
          labelText="Search"
          id="search"
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            value: search,
            onChange: (e) => setSearch(e.target.value),
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
        />
      </div>

      <TablePaginate
        count={count}
        page={page}
        setPage={setPage}
        size={size}
        columns={columns}
        data={items}
      />
    </div>
  );
}

function Action({ cell, onCloseModal, setItems }) {
  const [openDialogDel, setOpenDialogDel] = React.useState(false);

  const handleOpenDel = () => {
    setOpenDialogDel(true);
  };

  const handleCloseDel = () => {
    setOpenDialogDel(false);
  };

  const handleDelete = async (id) => {
    try {
      await configService.remove(id);
      setItems((prev) => prev.filter((config) => config._id !== id));
      handleCloseDel();
    } catch (error) {
      console.log("🍕 ~ error:", error);
    }
  };

  return (
    <div
      className="actions-right"
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <Link to={"/admin/configs/edit/" + cell.row.original._id}>
        <Button justIcon round simple color="primary" className="edit">
          <Edit />
        </Button>
      </Link>

      <DeleteIcon
        onClick={handleOpenDel}
        style={{ fontSize: "20px", color: "#ce2727", cursor: "pointer" }}
      />

      <Dialog
        open={openDialogDel}
        onClose={handleCloseDel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm remove config?"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseDel} color="transparent">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDelete(cell.row.original._id);
            }}
            color="success"
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

Action.propTypes = {
  cell: PropTypes.any,
  setItems: PropTypes.any,
};
